
import CloudSunny from "../../../assets/duotone/CloudSunny.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CloudSunnyIcon({ className, dataTestid = "CloudSunnyIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <CloudSunny data-testid={dataTestid} className={classes} {...rest} />
  );
}
